import AdvisorPageHero from '@/components/advisor/AdvisorPageHero';
import AdvisorSignupForm from '@/components/advisor/AdvisorSignupForm';

function AdvisorConnectPage() {
  return (
    <div className="fhxd-chrome-top">
      <AdvisorPageHero ctaLabel="Advisor Opportunities" ctaHref="/advisor-opportunities" />
      <AdvisorSignupForm
        showLoginLink={false}
        showSupportInfo={false}
        defaultReferredBy="Social Media"
        heading="Advisor Sign Up"
      />
    </div>
  );
}

export default AdvisorConnectPage;
